import module from './home.module';
import './home.controller';
import './home.style.scss';

export default module.name;